import {
  AgentRequestContext,
  ProductVariantAgentTool,
} from '@tiendanube/common';
import { Variant } from 'domains/Catalog/Products/pages/components/Variants/types';
import { AgentChatActionBusState, AI_FIELDS } from './AgentChatActionBusTypes';

function mapVariantToContext(
  variant: Variant,
): ProductVariantAgentTool['fields'] {
  return {
    prices: {
      sell_price: Number.parseInt(variant.price) || 0,
      promotional_price: Number.parseInt(variant.promotionalPrice) || 0,
      cost_price: Number.parseInt(variant.costPrice) || 0,
      show_in_store: variant.pricePublished,
    },
    weights_and_dimensions: {
      weight: Number.parseFloat(variant.weight) || 0,
      depth: Number.parseFloat(variant.depth) || 0,
      width: Number.parseFloat(variant.width) || 0,
      height: Number.parseFloat(variant.height) || 0,
    },
    codes: {
      sku: variant.sku,
      barcode: variant.barcode,
    },
    distribution_center: variant.locationId || '',
    show_in_store: variant.visible,
    social_media: {
      mpn: variant.mpn || '',
      age_range: variant.ageGroup || '',
      gender: variant.gender || '',
    },
  };
}

function mapStatesToAgentChatPanelContext(
  states: AgentChatActionBusState = {},
): { context: AgentRequestContext; imageUrls: string[] } {
  return {
    imageUrls: [...(states[AI_FIELDS.PRODUCT_IMAGES]?.value || [])],
    context: {
      product: {
        name: states[AI_FIELDS.PRODUCT_NAME]?.value,
        description: states[AI_FIELDS.PRODUCT_DESCRIPTION]?.value,
        seo: {
          title: states[AI_FIELDS.PRODUCT_SEO_TITLE]?.value,
          description: states[AI_FIELDS.PRODUCT_SEO_DESCRIPTION]?.value,
          url: states[AI_FIELDS.PRODUCT_SEO_URL]?.value,
        },
        tags: states[AI_FIELDS.PRODUCT_TAGS]?.value,
        prices: states[AI_FIELDS.PRODUCT_PRICES]?.value,
        weights_and_dimensions:
          states[AI_FIELDS.PRODUCT_WEIGHTS_AND_DIMENSIONS]?.value,
        brand: states[AI_FIELDS.PRODUCT_BRAND]?.value,
        categories: states[AI_FIELDS.PRODUCT_CATEGORIES]?.value,
        highlights: states[AI_FIELDS.PRODUCT_HIGHLIGHTS]?.value,
        is_published: states[AI_FIELDS.PRODUCT_PUBLISHED]?.value,
        free_shipping: states[AI_FIELDS.PRODUCT_FREE_SHIPPING]?.value,
        is_digital: states[AI_FIELDS.PRODUCT_IS_DIGITAL]?.value,
        variants: states[AI_FIELDS.PRODUCT_VARIANTS]?.value,
      },
    },
  };
}
export { mapVariantToContext, mapStatesToAgentChatPanelContext };
